/*const isTestProduct = window.location.pathname === "/products/spulmaschinen-blatter-test";*/

// AFTER
const isTestProduct = window.location.pathname === "/products/spulmaschinen-blatter" 
  && window.location.search.includes("view=spulmittel-blatter_abo");

const isBundleNew = window.location.pathname === "/products/pack-economique";

var priceValue = isTestProduct ? {
  unit: ["0,23€", "0,25€", "0,27€", "0,31€"],
  old: ["99,96€", "74,97€", "49,98€", ""],
  current: ["74,97€", "59,98€", "42,48€", "24,99€"],
  discount: ["-25%", "-20%", "-15%", ""]
} : isBundleNew ? {
  unit: ["0,28€", "0,19€", "0,14€"],
  old: ["", "134,70€", "269,40€"],
  current: ["44,90€", "90,27€", "134,70€"],
  discount: ["", "-33%", "-50%"]
} : {
  unit: ["0.28€", "0.18€", "0.14€"],
  old: ["", "68,70€", "137,40€"],
  current: ["22,90€", "44,90€", "68,70€"],
  discount: ["", "-35%", "-50%"]
};

var q = (a, b) => b ? a.querySelector(b) : document.querySelector(a);
var qa = (a, b) => b ? a.querySelectorAll(b) : document.querySelectorAll(a);
function insertEle(target, position, element, checkEle) {
  if (!checkEle) {
    typeof element === "string" ? target.insertAdjacentHTML(position, element) : target.insertAdjacentElement(position, element);
  }
}
function getChildIndex(childEle) {
  return Array.from(childEle.parentNode.children).indexOf(childEle);
}
function waitFor(condition, callback, endTime = 1e4, pollInterval = 25) {
  if (condition()) {
    callback(condition());
  } else if (endTime > 0) {
    setTimeout(() => {
      waitFor(condition, callback, endTime - pollInterval, pollInterval);
    }, pollInterval);
  }
}
function safeExpLog(key, value) {
  try {
    if (typeof expLog === "function") expLog(key, value);
  } catch(e) {}
}

function updateBlockTitle() {
  const selectedBar = q(".kaching-bundles__bar:has(input:checked)");
  const blockTitle = q(".kaching-bundles__block-title");
  if (!blockTitle) return;
  const selectedTitle = selectedBar
    ? selectedBar.querySelector(".kaching-bundles__bar-title")
    : q(".kaching-bundles__bar .kaching-bundles__bar-title");
  if (selectedTitle) {
    blockTitle.innerHTML = `2. Wähle dein Angebot:&nbsp;<span style="color: #175C2A;">${selectedTitle.textContent.trim()}</span>`;
  }
}

const style = document.createElement("style");
style.textContent = `
  @media screen and (max-width: 749px) {
    .spulmittel-blatter .product__subtitle__usp + .shopify-block
    .kaching-bundles__block > .kaching-bundles__block-title::after {
      content: "" !important;
      display: none !important;
    }
  }
  .spulmittel-blatter .kaching-bundles__block-title::before,
  .spulmittel-blatter .kaching-bundles__block-title::after {
    display: none !important;
    content: none !important;
    flex-grow: 0 !important;
    height: 0 !important;
  }
  .kaching-bundles__bars .kaching-bundles__bar .kaching-bundles__bar-wrapper {
    padding: 16px 8px 6px !important;
  }

  /* Non-selected bundle cards — white background, grey text */
  .spulmittel-blatter .kaching-bundles__bars .kaching-bundles__bar .kaching-bundles__bar-container {
    padding: 5px !important;
  }
  .spulmittel-blatter .kaching-bundles__bars .kaching-bundles__bar .kaching-bundles__bar-wrapper {
    background: #fff !important;
    mix-blend-mode: normal !important;
    height: 100% !important;
  }
  .spulmittel-blatter .kaching-bundles__bars .kaching-bundles__bar:not(:has(input:checked)) .kaching-bundles__bar-title {
    color: #999 !important;
  }
  .spulmittel-blatter .kaching-bundles__bars .kaching-bundles__bar:not(:has(input:checked)) .kaching-bundles__bar-subtitle {
    color: #bbb !important;
  }

  /* Selected card — green gradient, dark text */
  .spulmittel-blatter .kaching-bundles__bars .kaching-bundles__bar input:checked + .kaching-bundles__bar-container .kaching-bundles__bar-wrapper {
    background: linear-gradient(180deg, #e3f9d7 32.88%, #fff 105.28%) !important;
  }
  .spulmittel-blatter .kaching-bundles__bars .kaching-bundles__bar input:checked + .kaching-bundles__bar-container .kaching-bundles__bar-title {
    color: #121212 !important;
  }
  .spulmittel-blatter .kaching-bundles__bars .kaching-bundles__bar input:checked + .kaching-bundles__bar-container .kaching-bundles__bar-subtitle {
    color: #484c46 !important;
  }
`;
document.head.appendChild(style);

if (isTestProduct) {
  const testStyle = document.createElement("style");
  testStyle.textContent = `
    .spulmittel-blatter .product__price[data-active="3"] li[data-index="3"] {
      display: inline-block;
    }
    .spulmittel-blatter .product__price[data-active="3"] li[data-index="3"]:empty {
      position: absolute;
      visibility: hidden;
    }
  `;
  document.head.appendChild(testStyle);
}

if (isTestProduct) {
  waitFor(
    () => q(".product-form__buttons"),
    () => {
      const buttons = q(".product-form__buttons");
      if (!buttons.querySelector(".delivery-notice")) {
        buttons.insertAdjacentHTML("beforeend", `
          <p class="delivery-notice" style="
            text-align: center;
            font-size: 15px;
            font-weight: 600;
            color: #121212;
            margin-top: 10px;
            margin-bottom: 0;
          ">Lieferung innerhalb von 2-3 Werktagen</p>
        `);
      }
    }
  );
}

q('[data-type="add-to-cart-form"] .product-form__buttons .product-form__submit > span').innerHTML = "COMMANDER MAINTENANT";

waitFor(
  () => q(".kaching-bundles__bars") && q(".kaching-bundles__bar-content .kaching-bundles__bar-label"),
  () => {
    if (isTestProduct) {
      updateBlockTitle();

      const observer = new MutationObserver(() => updateBlockTitle());
      observer.observe(q(".kaching-bundles__bars"), {
        subtree: true,
        attributes: true,
        attributeFilter: ["checked", "class"]
      });
    }

    q(".kaching-bundles__bars").addEventListener("click", (e) => {
      const targetCard = e.target.closest(".kaching-bundles__bar");
      if (targetCard) {
        const index = getChildIndex(targetCard, q(".kaching-bundles__bars"));
        q(".product__price[data-active]").dataset.active = index;
        safeExpLog("selected-index", index);
        if (isTestProduct) {
          updateBlockTitle();
          // Auto-select matching subscription frequency pill
          if (typeof window.__selectSubscriptionPill === 'function') {
            window.__selectSubscriptionPill(index);
          }
        }
      }
    });

    qa(".kaching-bundles__bar-content .kaching-bundles__bar-label").forEach((ele, index) => {
      const parentEle = ele.closest(".kaching-bundles__bar-content");
      insertEle(
        q(parentEle, ".kaching-bundles__bar-price"),
        "afterend",
        ele
      );
    });
  }
);

insertEle(
  q('form[data-type="add-to-cart-form"]'),
  "beforebegin",
  `<div class="product__price" data-active="0">
    <div class="product__price__unit">Seulement <ul>${priceValue.unit.map((item, index) => `<li data-index="${index}">${item}</li>`).join("")}</ul>/lavage</div>
    <div class="product__price__difference">
      <ul class="product__price__difference__old">${priceValue.old.map((item, index) => `<li data-index="${index}">${item}</li>`).join("")}</ul>
      <ul class="product__price__difference__current">${priceValue.current.map((item, index) => `<li data-index="${index}">${item}</li>`).join("")}</ul>
      <ul class="product__price__difference__discount">${priceValue.discount.map((item, index) => `<li data-index="${index}">${item}</li>`).join("")}</ul>
    </div>
  </div>`,
  q(".product__price")
);